import clsx from 'clsx'
import copyIcon from '../assets/copy-icon.svg'

interface LinkCardProps {
  isLoading: boolean
  promotionLink: string
  isButtonsDisabled: boolean
  onCopy: () => void
}

export function LinkCard({
  isLoading,
  promotionLink,
  isButtonsDisabled,
  onCopy,
}: LinkCardProps) {
  return (
    <div className='mt-[32px] flex w-full flex-col gap-[18px]'>
      <p
        className='font-black text-[16px] leading-normal text-[#333] not-italic'
        data-testid='referral-link-title'
      >
        My Referral Link
      </p>

      <div className='relative flex h-[112px] w-full flex-col items-center rounded-[28px] border border-solid border-[#f4f4f4] bg-white p-4 shadow-[0px_4px_10px_rgba(0,0,0,0.05)]'>
        <div className='flex w-full items-center gap-[12px]'>
          <div className='flex h-[48px] flex-1 items-center overflow-hidden rounded-[16px] bg-[#f5f5f5] px-[12px]'>
            <p
              className='break-all font-medium text-[11px] leading-tight text-black not-italic'
              data-testid='referral-link'
            >
              {isLoading ? 'Loading...' : promotionLink || 'No link available'}
            </p>
          </div>

          <button
            onClick={onCopy}
            disabled={isButtonsDisabled}
            className={clsx(
              'flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-[16px]',
              isButtonsDisabled
                ? 'cursor-not-allowed bg-gray-400'
                : 'bg-[#6e59cd]',
            )}
            data-testid='copy-link-button'
            aria-label='Copy Link'
          >
            <img alt='' className='size-[20px]' src={copyIcon} />
          </button>
        </div>

        <p className='mt-[12px] whitespace-nowrap text-center font-medium text-[12px] leading-normal text-[rgba(0,0,0,0.4)] not-italic'>
          Share this link to invite your friends
        </p>
      </div>
    </div>
  )
}
